// MF-67 — White card surface for Journal forms/panels, so content sits on a raised surface instead
// of flat on the page background. Optional title + description; `footer` renders the action bar.
import { Paper, Typography } from '@mui/material'

const FormCard = ({ title, description, footer, children, className = '', style }) => (
  <Paper
    variant='outlined'
    className={className}
    style={{ borderRadius: 12, borderColor: 'rgb(226, 232, 240)', overflow: 'hidden', ...style }}
  >
    <div className='flex flex-col' style={{ padding: 24, gap: 24 }}>
      {title ? (
        <div className='flex flex-col' style={{ gap: 4 }}>
          <Typography style={{ fontSize: 15, fontWeight: 600, color: 'rgb(15, 23, 42)' }}>{title}</Typography>
          {description ? (
            <Typography style={{ fontSize: 13, color: 'rgb(100, 116, 139)' }}>{description}</Typography>
          ) : null}
        </div>
      ) : null}
      {children}
    </div>
    {footer ? (
      <div
        className='flex items-center justify-end gap-2'
        style={{
          padding: '12px 24px',
          borderTop: '1px solid rgb(226, 232, 240)',
          background: 'rgb(248, 250, 252)'
        }}
      >
        {footer}
      </div>
    ) : null}
  </Paper>
)

export default FormCard
